import { useAppSelector } from '@/store/hooks';
import { selectUserChannel } from '@/store/slices/user/selectors';
import { isTownhallChannel, isWebinarChannel } from '@/utils/project-types/project-type-guards';
import Container from '@ui/container/container';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const webinarImageArray = [
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/patches/patch-1.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/patches/patch-2.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/patches/patch-3.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/patches/patch-4.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/patches/patch-5.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/patches/patch-6.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/patches/patch-7.webp`,
];

const townhallImageArray = [
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/stubs/stub-1-v2.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/stubs/stub-2-v2.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/stubs/stub-3.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/stubs/stub-4.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/stubs/stub-5.webp`,
  `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/stubs/stub-6.webp`,
];

// incrementer
function* numberIncrementer() {
  let index = 0;
  while (true) {
    yield index++;
  }
}

const indexGenerator = numberIncrementer();

function getIndex(max: number) {
  return (indexGenerator.next()?.value || 0) % max;
}

export default function ComingSoonImage() {
  const userChannel = useAppSelector(selectUserChannel);
  const channelIsWebinar = isWebinarChannel(userChannel?.type);
  const channelIsTownhall = isTownhallChannel(userChannel?.type);
  const location = useLocation();

  // to cycle through the images on navigation, use the generator function to progressively
  // climb the index number
  const image = useMemo(() => {
    if (channelIsWebinar) {
      return webinarImageArray[getIndex(webinarImageArray.length)];
    }
    return townhallImageArray[getIndex(townhallImageArray.length)];

    // location.pathname is extra - we want to jump to the next image every navigation
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelIsWebinar, channelIsTownhall, location.pathname]);

  return (
    <Container
      background={'transparent'}
      data-component="ComingSoon"
      width={channelIsWebinar ? '230px' : '300px'}
      maxWidth="fit-content"
    >
      {image && <img src={image} alt="Coming soon" style={{ maxWidth: '100%' }} />}
    </Container>
  );
}
